<template>
  <div class="app-wrapper relative overflow-x-hidden h-screen">
    <Loader :show="loading" />
    <main id="app" class="swiper-container">
      <swiper ref="appSwiper" :key="appKey"
        class="swiper" :options="swiperOption"
        @slideChange="handleIndex">
        <swiper-slide class="app-page">
          <MainSlide />
        </swiper-slide>
        <swiper-slide v-for="(page, idx) in secondaryPage" :key="makeVueKey(secondaryPage[idx])"
          :data-swiper-autoplay="calcSlideInterval(page.slide_interval)"
          class="app-page">
          <SlideItem :page="page" :isInViewport="(idx + 1) === activeIndex" />
        </swiper-slide>
      </swiper>
    </main>
    <SalesPopup :forceShow="false" :content="popupContent" @reset="resetPopup" />
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import { mapActions, mapGetters } from 'vuex'

import SalesPopup from './components/shared/SalesPopup'
import Loader from './components/shared/Loader'
import MainSlide from './components/MainSlide'
import SlideItem from './components/SlideItem'
import { IO_CHANNELS } from './websocket'
import { makeVueKey } from './utils/lang'

export default {
  name: 'App',
  components: {
    Loader,
    MainSlide,
    SlideItem,
    SalesPopup
  },
  created() {
    this.fetchAppData()
  },
  data() {
    return {
      updater: null,
      popupContent: null,
      activeIndex: null,
    }
  },
  mounted() {
    this.subscribeWebsocket()
  },
  methods: {
    makeVueKey,
    ...mapActions([
      'boostrapApp',
      'logUpdates',
      'setLoading',
      'setPopup',
      'pushPopup',
      'popPopup',
      'setSlideSetting',
      'setZodiacPeople',
      'setSecondaryPage',
      'setZodiacRanking',
      'setBirthdayThisMonth',
    ]),
    fetchAppData() {
      this.setLoading(true)
      this.$socket.emit(IO_CHANNELS.APP_BOOTSTRAP)
    },
    subscribeWebsocket() {
      this.$socket.on(IO_CHANNELS.APP_BOOTSTRAP, appData => {
        console.log('[SYSTEM] AppData', appData)
        this.boostrapApp(appData)

        console.log('Updated at', this.lastUpdatedAt.toLocaleString())
        console.log('Next update at', this.nextUpdatePoint.toLocaleString())
        setTimeout(() => {
          this.setLoading(false)
        }, 250)
      })
      this.$socket.on(IO_CHANNELS.SLIDE_SETTING, res => {
        this.setSlideSetting(res)
      })
      this.$socket.on(IO_CHANNELS.ZODIAC_PEOPLE, res => {
        this.setZodiacPeople(res)
      })
      this.$socket.on(IO_CHANNELS.SECONDARY_PAGE, res => {
        this.setSecondaryPage(res)
      })
      this.$socket.on(IO_CHANNELS.ZODIAC_RANKING, res => {
        this.setZodiacRanking(res)
      })
      this.$socket.on(IO_CHANNELS.BIRTHDAY_THIS_MONTH, res => {
        this.setBirthdayThisMonth(res)
      })
      this.$socket.on(IO_CHANNELS.SALES_FIGURE, res => {
        this.pushPopup(res)
      })
    },
    countToUpdate(nextPoint = null) {
      const next = nextPoint || this.nextUpdatePoint
      if(next) {
        const diff = next.getTime() - this.lastUpdatedAt.getTime()
        this.updater && clearTimeout(this.updater)
        this.updater = setTimeout(() => {
          this.fetchAppData()
        }, diff)
      }
    },
    resetPopup() {
      this.popupContent = null
      setTimeout(() => {
        if(this.popupQueue.length) {
          this.popupContent = this.popupQueue.shift()
        }
      }, (this.slideSetting.popup_rest_duration || 2) * 1000)
    },
    handleIndex() {
      this.activeIndex = this.$refs.appSwiper.$swiper.activeIndex
    },
    calcSlideInterval(itv) {
      const res = (itv || this.slideSetting.autoslide_interval || 20)
      return res * 1000
    },
  },
  computed: {
    ...mapGetters([
      'appMeta',
      'lastUpdatedAt',
      'nextUpdatePoint',
      'resetDailyAt',
      'popupQueue',
      'loading',
      'slideSetting',
      'secondaryPage',
    ]),
    swiperOption() {
      if(this.slideSetting.autoslide_interval) {
        const { autoslide_interval, default_transition } = this.slideSetting
        const config = {
          effect: default_transition,
          fadeEffect: {
            crossFade: true
          },
          loop: false,
          speed: 500,
          autoplay: {
            enabled: autoslide_interval > 0,
            delay: autoslide_interval * 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          },
        }
        return config
      }
      return null
    },
    appKey() {
      return this.makeVueKey(this.slideSetting)
    }
  },
  watch: {
    nextUpdatePoint(newVal) {
      this.countToUpdate(newVal)
    },
    popupQueue(queue) {
      if(!this.popupContent && queue.length) {
        this.popupContent = queue.shift()
      }
    },
  }
}
</script>

<style>
@import 'assets/app.css';
.swiper-slide.app-page {
  height: 100vh;
  overflow: hidden;
}
</style>
